import * as React from 'react';
import styled from 'styled-components';
import Media from 'react-media';
import { formatProduct } from 'Jsx/Utils/buyProduct';
import { CourseCardV3, CourseCardV3Wrapper } from 'Jsx/Shared/CourseCardV3';
import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';
import {
  Wrapper,
  Image,
  Prices,
  Enrollments,
  CardBody,
  Title,
  AddToCart,
} from 'Jsx/Shared/CourseCardV3/components';
import CourseCardV3Mobile from 'Jsx/Shared/CourseCardV3/layouts/CourseCardV3Mobile';

const DesktopCourses = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: flex;
    width: 100%;
  }
`;

const MobileCourses = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;

const Root = styled.div`
  .CourseCardComponent {
    background-color: #fafafa;
    display: flex;
    position: relative;
    flex-direction: column;
    @media (min-width: 768px) {
      flex-direction: row;
    }
  }

  .ImageComponent > .ImageComponentWrapper {
    padding-bottom: 0;
    height: 189px !important;
    @media (min-width: 768px) {
      height: 227px !important;
    }
    @media (min-width: 1140px) {
      height: 176px !important;
      width: 267px !important;
    }
    @media (min-width: 1440px) {
      width: 302px !important;
      height: 200px !important;
    }
  }

  .AddToCartComponent {
    background-color: transparent;
  }
`;

export const HighlightedCard = props => (
  <Root>
    <CourseCardV3Wrapper {...props}>
      <Wrapper>
        <Image />
        <CardBody>
          <Title />
          <Enrollments />
          <Prices />
          <AddToCart />
        </CardBody>
      </Wrapper>
    </CourseCardV3Wrapper>
  </Root>
);

const CourseCard: React.FC<CourseCardProps> = props => {
  return (
    <React.Fragment>
      <Media query="(min-width: 768px)">
        {matches =>
          matches ? (
            <DesktopCourses>
              <CourseCardV3
                courseCardPage="SEARCH_LANDING"
                product={formatProduct(props, 'course')}
                {...props}
              />
            </DesktopCourses>
          ) : (
            <MobileCourses>
              <CourseCardV3Mobile
                courseCardPage="SEARCH_LANDING"
                product={formatProduct(props, 'course')}
                {...props}
              />
            </MobileCourses>
          )
        }
      </Media>
    </React.Fragment>
  );
};

export default CourseCard;
